<template>
  <div class="hand-box">
    <div class="signature" ref="signature">
      <div class="title">手写签批</div>
      <div class="cancel" @click="close">
        x
      </div>
      <hr class="divide" />
      <canvas
        id="myCanvas"
        ref="canvas"
        @touchstart="touchStart"
        @touchmove="touchMove"
        @touchend="touchEnd"
      ></canvas>
      <div class="operate-btn-wrap">
        <button @click="commit">提交</button>
        <button @click="overwrite">清除</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "signature",
  props: {},
  data: function () {
    return {
      canvasTxt: null,
      stageInfo: {},
      startX: 0,
      startY: 0,
      points: [],
      isStart: false,
      uuid: "",
    }
  },
  created: function () {},
  mounted: function () {
    setTimeout(() => {
      this.init()
    }, 300)
  },
  methods: {
    // 初始化canvas
    init: function () {
      let canvas = this.$refs.canvas
      console.log(this.$refs.signature.offsetHeight)
      canvas.height = this.$refs.signature.offsetHeight
      canvas.width = this.$refs.signature.offsetWidth
      this.canvasTxt = canvas.getContext("2d")
      this.canvasTxt.lineWidth = 5
      this.stageInfo = canvas.getBoundingClientRect()
    },
    // 开始绘制
    touchStart: function (ev) {
      this.isStart = true
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length === 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left - 10,
          y: ev.targetTouches[0].clientY - this.stageInfo.top - 10,
        }
        this.startX = obj.x
        this.startY = obj.y
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
      }
    },
    // 绘制中
    touchMove: function (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length === 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left - 10,
          y: ev.targetTouches[0].clientY - this.stageInfo.top - 10,
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.startY = obj.y
        this.startX = obj.x
        this.points.push(obj)
      }
    },
    // 绘制结束
    touchEnd: function (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length === 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top,
        }
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
        this.points.push({ x: -1, y: -1 })
      }
    },
    // 重新签名
    overwrite: function () {
      this.canvasTxt.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      )
      this.points = []
    },
    getuuid: function () {
      var s = []
      var hexDigits = "0123456789abcdef"
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-"

      var uuid = s.join("")
      this.uuid = uuid
    },
    //提交后端
    commit: function () {
      this.getuuid()
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/sealHandPainted/saveSealHandPainted",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          sealUUID: that.uuid,
          sealBase64: that.$refs.canvas.toDataURL(),
        }),
        success: function (data) {
          if (data.data) {
            that.$emit("hand-write", {
              sealBase64: that.$refs.canvas.toDataURL(),
              sealUUID: that.uuid,
              ishand: true,
            })
            that.$parent.isShowHandWrite = false
            that.$parent.isShowModal = true
          }
          if (data.errCode == -1) {
            alert("保存失败")
          }
        },
        error: function (data) {
          console.log(data)
        },
      })
    },
    // 提交签名
    // commit: function () {
    //   this.$emit("hand-write", this.$refs.canvas.toDataURL())
    //   this.$parent.isShowHandWrite = false
    //   this.$parent.isShowModal = true
    // },
    // base64转file
    base64ToFile: function (dataurl) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      let blob = new Blob([u8arr], { type: mime })
      blob.lastModifiedDate = new Date()
      blob.name = "签名"
      return blob
    },
    close: function () {
      this.$parent.isShowHandWrite = false
    },
  },
}
</script>

<style scoped>
.hand-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 1002;
}
.signature {
  width: 100%;
  height: 80%;
}
.title {
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  top: 1%;
  left: 3%;
}
.cancel {
  position: absolute;
  font-size: 15px;
  right: 5%;
  top: 1%;
  z-index: 999;
}
.divide {
  margin-top: 10%;
}
.operate-btn-wrap {
  text-align: center;
}
.operate-btn-wrap button:first-child {
  margin-right: 30px;
}
</style>
